let APIServer = 'https://api-staging.rocked.us/';
if (process.env.REACT_APP_NODE_ENV === 'production') {
  APIServer = 'https://api.rocked.us/';
}

export const apiEndpoints = {
  // common
  GET_DEALERSHIPS: '/dealerships',
  GET_JOURNEYS: '/journeys',
  GET_JOURNEYS_LIST: '/rockedAdmin/v1/journey/list',

  GET_PUBLISH_DATES: '/doses/publish_dates',
  GET_DEALERSHIPS_LIST: `${APIServer}dealerships/list`,
  GET_DEPARTMENTS: `${APIServer}departments`,
  GET_PLANS: `${APIServer}plans`,
  GET_STORIES: `${APIServer}doses/get_all_stories`,
  CHECK_ACCESS: `${APIServer}console/check-access`,
  DEALER_MASTER_CEANUP_DROPDOWNS: `${APIServer}dealerships/master_metadata/lists`,

  // INTERACTION
  INTERACTION_UPLOAD: `${APIServer}interactions/admin/upload`,

  // ADMIN USERS
  ADMIN_USER_LIST: `${APIServer}rockedAdmin/v1/admin/list`,
  ADMIN_USER_DETAIL: `${APIServer}rockedAdmin/v1/admin/detail/ID`,
  ADMIN_USER_CREATE: `${APIServer}rockedAdmin/v1/admin/create`,
  ADMIN_USER_UPDATE: `${APIServer}rockedAdmin/v1/admin/update/ID`,

  // RNP
  GET_RNP_LIST: `${APIServer}rockedAdmin/v1/rockedNetworkPartners`,
  GET_RNP_DETAILS: `${APIServer}rockedAdmin/v1/rockedNetworkPartners/ID`,
  CREATE_RNP: `${APIServer}rockedAdmin/v1/rockedNetworkPartners`,
  UPDATE_RNP_DETAILS: `${APIServer}rockedAdmin/v1/rockedNetworkPartners/ID`,
  DELETE_RNP: `${APIServer}rockedAdmin/v1/rockedNetworkPartners/ID`,

  // GUIDES
  GUIDE_TAGS: `${APIServer}tags?type=guide`,
  GUIDE_CREATE: `${APIServer}guides`,
  GUIDE_UPDATE: `${APIServer}guides/GUIDE_ID`,

  // JOURNEY
  JOURNEY_LEVEL_DETAILS: `${APIServer}levels/LEVEL_ID`,
  JOURNEY_CAPSTONE_DETAILS: `${APIServer}capstones?levelId=LEVEL_ID`,
  JOURNEY_SALES_PIPELINE_STATUS: `${APIServer}dealerships/sale_pipeline_status`,
  JOURNEY_CUSTOM_DEPARTMENT: `${APIServer}departments/custom_department_role`,
  JOURNEY_CAPSTONE: `${APIServer}capstones`,
  JOURNEY_CAPSTONE_BY_ID: `${APIServer}capstones/CAP_ID`,
  JOURNEY_LEVEL: `${APIServer}levels`,
  JOURNEY_TAGS: `${APIServer}tags`,
  JOURNEY_GUIDE_BY_ID: `${APIServer}guides/GUIDE_ID`,
  JOURNEY_CAPSTONE_ACTIVITY: `${APIServer}capstone_activities`,
  JOURNEY_CAPSTONE_ACTIVITY_BY_ID: `${APIServer}capstone_activities/CAP_ACT_ID`,
  JOURNEY_GUIDE_LEVEL: `${APIServer}guides/GUIDE_ID/level`,
  JOURNEY_CAPSTONE_ACTIVITY_SEQUENCE: `${APIServer}capstone_activities/sequence`,
  JOURNEY_GUIDE_SEQUENCE: `${APIServer}rockedAdmin/v1/journey/learningUnits/sequence`,
  JOURNEY_LEVEL_SEQUENCE: `${APIServer}levels/sequence`,
  JOURNEY_CAPSTONE_ACTIVITY_LEVEL: `${APIServer}capstone_activities?levelId=LEVEL_ID`,
  JOURNEY_CAPSTONE_LEVEL: `${APIServer}capstones/CAP_ID?levelId=LEVEL_ID`,
  JOURNEY_CHECKIN: `${APIServer}checkin/admin/CHECKIN_ID`,
  JOURNEY_CHECKIN_UPDATE: `${APIServer}checkin/admin/journey/CHECKIN_ID`,
  JOURNEY_CHECKIN_CREATE: `${APIServer}checkin/admin/journey/create`,
  JOURNEY_INSTRUCTOR: `${APIServer}sources/by_type?type=INSTRUCTOR`,
  JOURNEY_TAG_JOURNEY: `${APIServer}tags?type=journey`,
  JOURNEY_LEVEL_BY_JID: `${APIServer}levels?journeyId=JID`,
  JOURNEY_LIST: `${APIServer}rules/admin/journey/list`,
  JOURNEY_ROLE_ASSIGN: `${APIServer}journeys/ID/department_roles`,
  JOURNEY_DEP_ROLE: `${APIServer}departments/admin/ID/department_roles`,
  JOURNEY_ASSIGN_TO_ROLE: `${APIServer}journeys/assign_department_roles`,
  JOURNEY_ASSIGN_TO_RULE: `${APIServer}rules/admin/journey/add/ID`,
  JOURNEY_CATEGORIES: `${APIServer}categories`,
  JOURNEY_COLLECTION_LIST: `${APIServer}collections/admin/list`,
  JOURNEY_BY_ID: `${APIServer}journeys/ID`,
  JOURNEY_TAKEAWAY_CREATE: `${APIServer}journeys/takeaways`,
  JOURNEY_TAKEAWAY_INFO: `${APIServer}journeys/takeaways/ID`,
  JOURNEY_DEPARTMENTS: `${APIServer}journeys/admin/departments/ID`,
  JOURNEY_AI_ROLEPLAY_LIST: `${APIServer}rockedAdmin/v1/journey/eligibleAIExercises/ID`,
  JOURNEY_GUIDES_LIST: `${APIServer}rockedAdmin/v1/level/ID`,
  JOURNEY_ADD_AI_ROLEPLAY: `${APIServer}rockedAdmin/v1/journey/addAIExercise`,
  JOURNEY_AI_EXERCISE_LEVEL_CHANGE: `${APIServer}rockedAdmin/v1/journey/learningUnits/changeLevel`,

  // COLLECTION
  COLLECTION_FILTERS: `${APIServer}collections/admin/filters`,
  COLLECTION_UPDATE_JOURNEY: `${APIServer}collections/admin/update_journey/JOURNEY_ID`,
  COLLECTION_CREATE: `${APIServer}collections/admin/create`,
  COLLECTION_UPDATE: `${APIServer}collections/admin/update/COLLECTION_ID`,
  COLLECTION_DETAIL: `${APIServer}collections/admin/details/ID`,
  COLLECTION_REMOVE: `${APIServer}collections/admin/remove/ID`,
  COLLECTION_ASSESMENT: `${APIServer}collections/admin/assessment/create`,
  COLLECTION_ASSESMENT_UPDATE: `${APIServer}collections/admin/assessment/update`,
  COLLECTION_JOURNEYS: `${APIServer}collections/admin/journey/guides/ID`,
  COLLECTION_QUESTIONS: `${APIServer}collections/admin/assessment/questions/ID?type=TYPE`,
  COLLECTION_RNP: `${APIServer}collections/admin/rocked_network_partner`,
  COLLECTION_EXPLORE_CAT: `${APIServer}collections/admin/explore_categories`,
  COLLECTION_RESOURCE_BASE_PATH: `${APIServer}rockedAdmin/v1/collection/COLLECTION_ID/resource`,
  COLLECTION_RESOURCE_DETAIL: `${APIServer}rockedAdmin/v1/collection/COLLECTION_ID/resource/RESOURCE_ID`,
  COLLECTION_RESOURCES_SAVE: `${APIServer}rockedAdmin/v1/collection/COLLECTION_ID/resource/save`,
  COLLECTION_RESOURCES: `${APIServer}rockedAdmin/v1/collection/COLLECTION_ID/resources`,
  COLLECTION_LOCK: `${APIServer}rockedAdmin/v1/collection/COLLECTION_ID/lock`,

  // AUTH
  AUTH_UPDATE_AUTHENTICATION: `${APIServer}app_authentication/AUTH_CLIENT_ID`,
  AUTH_APP_AUTHENTICATION: `${APIServer}app_authentication`,
  AUTH_GET_TOKEN: `${APIServer}admins/token`,
  AUTH_LOGIN: `${APIServer}admins/login`,
  AUTH_LOGIN_VERIFY: `${APIServer}admins/login_verify`,
  AUTH_GOOGLE_LOGIN: `${APIServer}rockedAdmin/v1/auth/google`,

  // PLAN
  PLAN_AUTHENTICATION: `${APIServer}plan_authentication/PLAN_ID`,
  PLAN_BY_ID: `${APIServer}plans/ID`,
  PLAN_JOURNEY_ASSIGN: `${APIServer}plans/PLAN_ID/assign_journeys`,
  PLAN_JOURNEY_UNASSIGN: `${APIServer}plans/PLAN_ID/unassign_journeys`,
  PLAN_JOURNEYS: `${APIServer}plans/ID/journeys`,
  PLAN_DEALERSHIP: `${APIServer}plans/ID/dealerships`,
  PLAN_JOURNEY: `${APIServer}plans/ID/journeys`,
  PLAN_STORY: `${APIServer}plans/ID/stories`,
  PLAN_DEALERS: `${APIServer}rockedAdmin/v1/plans/dealerships`,
  PLAN_DEALERS_BY_ID: `${APIServer}rockedAdmin/v1/plans/ID/dealerships`,
  PLAN_DEALER_ASSIGN: `${APIServer}rockedAdmin/v1/plans/ID/assign_dealerships`,
  PLAN_STORY_ASSIGN: `${APIServer}plans/ID/assign_stories`,
  PLAN_STORY_UNASSIGN: `${APIServer}plans/ID/unassign_stories`,

  // BADGES
  BADGES_UPDATE_BADGE: `${APIServer}badges/BADGE_ID`,
  BADGES_CREATE_BADGE: `${APIServer}badges`,
  BADGES_TYPES: `${APIServer}badges/types`,
  BADGE_BY_TYPE: `${APIServer}badges?type=TYPE`,

  // CUSTOM GROUP
  CG_LIST: `${APIServer}custom_groups/admin/list`,
  CG_CREATE: `${APIServer}custom_groups/admin/create`,
  CG_UPDATE: `${APIServer}custom_groups/admin/update/CG_ID`,
  CG_EMPLOYEES: `${APIServer}custom_groups/admin/employees/CG_ID/DEALER_ID`,
  CG_GET_DETAIL: `${APIServer}custom_groups/admin/CG_ID`,

  // STORY
  STORY_DOSE: `${APIServer}doses`,
  STORY_DOSE_UPDATE: `${APIServer}doses/DOSE_ID`,
  STORY_DOSE_BY_TYPE: `${APIServer}sources/by_type?type=DOSE_TYPE`,
  STORY_SOURCES: `${APIServer}sources`,
  STORY_SOURCES_UPDATE: `${APIServer}sources/ID`,
  STORY_DEALERSHIP_DEP: `${APIServer}dealership_departments`,
  STORY_DEALERSHIP_DEP_UPDATE: `${APIServer}dealership_departments/DEP_ID`,
  STORY_BY_DATE: `${APIServer}doses/daily?publishDate=DATE`,

  // DEALERSHIP
  DEALER_GET_BY_ID: `${APIServer}employees/admin/ID`,
  DEALER_CHILDREN_LIST: `${APIServer}dealerships/DEALER_ID/children_list`,
  DEALER_ROLES: `${APIServer}departments/admin/ID/department_roles`,
  DEALER_EMPLOYEE_UPDATE: `${APIServer}employees/admin/HASH/status`,
  DEALER_EMPLOYEE_CREATE: `${APIServer}employees/create`,
  DEALER_EMPLOYEE_RESTORE_HIGHEST_STREAK: `${APIServer}employee_streak/restore/ID `,
  DEALER_JOURNEY_PLAN: `${APIServer}plans/ID/journeys`,
  DEALER_REORDER_JOURNEY: `${APIServer}department_roles/dealership_assigned_journeys_reorder`,
  DEALER_GET_JOURNEY: `${APIServer}department_roles/assigned_journeys?dealershipId=DEALER_ID&departmentRoleId=ROLE_ID`,
  DEALER_ASSIGN_JOURNEY: `${APIServer}department_roles/override_journeys`,
  DEALER_CG_EMP_LIST: `${APIServer}custom_groups/admin/employees/ID/DEALER_ID`,
  DEALER_RULE_EMPLOYEES: `${APIServer}rules/admin/dealership/employees/ID/DEALER_ID`,
  DEALER_RULE_JOURNEYS: `${APIServer}rules/admin/dealership/journey/ID/DEALER_ID`,
  DEALER_RULE: `${APIServer}rules/admin/ID`,
  DEALER_DEP_EMPLOYEES: `${APIServer}employees?dealershipId=DEALER_ID&departmentId=DEP_ID&departmentRoleId=ROLE_ID`,
  DEALER_DEP_JOURNEYS: `${APIServer}department_roles/assigned_journeys?dealershipId=DEALER_ID&departmentId=DEP_ID&departmentRoleId=ROLE_ID`,
  DEALER_EMPLOYESS: `${APIServer}employees?dealershipId=DEALER_ID&departmentRoleId=ROLE_ID`,
  DEALER_OTP_DETAILS: `${APIServer}dealerships/otp_details/DEALER_ID`,
  DEALER_SALES_PIPELINE: `${APIServer}dealerships/sale_pipeline_status`,
  DEALER_PX_OWNERS: `${APIServer}dealerships/px_owner_list`,
  DEALER_PARENT_DEALERSHIP: `${APIServer}dealerships/DEALER_ID/parent_list`,
  DEALER_BY_ID: `${APIServer}dealerships/ID`,
  DEALER_DEPARTMENTS: `${APIServer}departments/admin/all_department_role?dealershipId=ID`,
  DEALER_CG: `${APIServer}custom_groups/admin/dealership/ID`,
  DEALER_RULES: `${APIServer}rules/admin/dealership/ID`,
  DEALER_OTP: `${APIServer}dealerships/view_otp`,
  DEALER_GUIDE_LIST: `${APIServer}guides/dealership/ID`,
  DEALER_RESIPIENT_LIST: `${APIServer}v2/dealerships/admin/DEALER_ID/department_roles_employees?journeyId=JOURNEY_ID&checkAssign=true`,
  DEALER_MESSAGES: `${APIServer}message/admin`,
  DEALER_SHARE_GUIDE: `${APIServer}share/admin/notification`,
  DEALER_JOURNEY_ASSIGN: `${APIServer}assign/admin`,
  DEALER_JOURNEYLIST: `${APIServer}journeys/dealership/ID`,
  DEALER_FILTER: `${APIServer}rockedAdmin/v1/dealership/filters`,
  DEALER_TAGS: `${APIServer}tags?type=dealership`,
  DEALER_TAG_ADD: `${APIServer}tags`,

  // DEVPANEL
  DEV_UPDATE_JOURNEY_INDEX: `${APIServer}console/elasticsearch/update-journeys-index`,
  DEV_UPDATE_TAG_INDEX: `${APIServer}console/elasticsearch/update-tags-index`,
  DEV_UPDATE_GUIDE_INDEX: `${APIServer}console/elasticsearch/update-guides-index`,
  DEV_UPDATE_STORY_INDEX: `${APIServer}console/elasticsearch/update-story-index`,
  DEV_UPDATE_GUIDE_VIEW_AVERAGE_COUNT: `${APIServer}console/scheduler/update-guide-view-rating-count`,
  DEV_UPDATE_AI_EXERCISE: `${APIServer}console/elasticsearch/update-ai-exercise-index`,
  DEV_UPDATE_ORGANIZATIONS_INDEX: `${APIServer}console/elasticsearch/update-organizations-index`,
  DEV_UPDATE_STATE_INDEX: `${APIServer}console/elasticsearch/update-state-index`,

  DEV_FETCH_LOGS: `${APIServer}monitor/admin/logs`,
  DEV_FETCH_LOG: `${APIServer}monitor/admin/log/LOG_ID`,
  DEV_FETCH_ZOMBIE_LIST: `${APIServer}employees/zombie/list`,
  UPDATE_ZOMBIE: `${APIServer}employees/zombie/ID`,
  DELETE_ZOMBIE: `${APIServer}employees/zombie/del/ID`,

  // CATEGORY
  CAT_FETCH: `${APIServer}rockedAdmin/v1/explore/getExternalPartnerTypes`,
  CAT_COLLECTION_BY_DEPT: `${APIServer}rockedAdmin/v1/explore/getCollectionsByPartnerDepartment`,
  CAT_COLLECTION_UPDATE: `${APIServer}rockedAdmin/v1/explore/addCollectionsToCategory`,
  CAT_COLLECTION_REORDER: `${APIServer}rockedAdmin/v1/explore/reorderCategoryCollections`,
  CAT_CATEGORY_REORDER: `${APIServer}rockedAdmin/v1/explore/reorderCategory`,
  CAT_CATEGORY_DELETE: `${APIServer}rockedAdmin/v1/explore/deleteCategory/CAT_ID`,
  CAT_CATEGORY_ADD: `${APIServer}rockedAdmin/v1/explore/addCategory`,
  CAT_CATEGORY_UPDATE: `${APIServer}rockedAdmin/v1/explore/updateCategory`,
  CAT_CATEGORY_COLLECTIONS: `${APIServer}rockedAdmin/v1/explore/getCollectionListForCategory`,

  // LEADERBOARD
  LB_FETCH: `${APIServer}rockedAdmin/v1/leaderboard/list`,
  LB_OVERVIEW: `${APIServer}rockedAdmin/v1/leaderboard/overview/ID`,
  LB_DETAILS: `${APIServer}rockedAdmin/v1/leaderboard/details/ID`,
  LB_CREATE: `${APIServer}rockedAdmin/v1/leaderboard/create`,
  LB_UPDATE: `${APIServer}rockedAdmin/v1/leaderboard/edit/ID`,
  LB_BY_ID: `${APIServer}rockedAdmin/v1/leaderboard/LB_ID`,
  LB_DEALER_FILTER: `${APIServer}rockedAdmin/v1/leaderboard/dealerships`,
  LB_DEPT: `${APIServer}rockedAdmin/v1/leaderboard/departments`,

  // QUIZ SERIES
  QUIZ_SERIES_FETCH: `${APIServer}rockedAdmin/v1/series/list`,
  QUIZ_SERIES_OVERVIEW: `${APIServer}rockedAdmin/v1/series/overview/ID`,
  QUIZ_SERIES_DETAILS: `${APIServer}rockedAdmin/v1/series/detail/ID`,
  QUIZ_SERIES_CREATE: `${APIServer}rockedAdmin/v1/series/create`,
  QUIZ_SERIES_UPDATE: `${APIServer}rockedAdmin/v1/series/update/ID`,
  QUIZ_SERIES_BY_ID: `${APIServer}rockedAdmin/v1/series/ID`,
  QUIZ_SERIES_DEPARTMENT: `${APIServer}rockedAdmin/v1/series/departments`,

  // QUIZ
  QUIZ_DETAILS: `${APIServer}rockedAdmin/v1/series/quiz/detail/ID`,
  QUIZ_CREATE: `${APIServer}rockedAdmin/v1/series/quiz/create`,
  QUIZ_UPDATE: `${APIServer}rockedAdmin/v1/series/quiz/update/ID`,
  QUIZ_BY_ID: `${APIServer}rockedAdmin/v1/series/quiz/ID`,

  // CONTESTS
  CON_FETCH: `${APIServer}rockedAdmin/v1/contest/list`,
  CON_DETAILS: `${APIServer}rockedAdmin/v1/contest/details/ID`,
  CON_DEALER_FILTER: `${APIServer}rockedAdmin/v1/contest/dealerships`,
  CON_DEPT: `${APIServer}rockedAdmin/v1/contest/departments`,
  CON_CREATE: `${APIServer}rockedAdmin/v1/contest/create`,
  CON_UPDATE: `${APIServer}rockedAdmin/v1/contest/edit/ID`,
  CON_BY_ID: `${APIServer}rockedAdmin/v1/contest/ID`,
  CON_CSV_METADATA: `${APIServer}rockedAdmin/v1/contest/importContestData`,
  CON_CREATE_CSV_METADATA: `${APIServer}rockedAdmin/v1/contest/createCSVMetaData`,
  CON_NET_PARTNER_LIST: `${APIServer}rockedAdmin/v1/rockedNetworkPartners/list`,

  // INAPP
  INAPP_FETCH: `${APIServer}inapp`,
  INAPP_UPDATE: `${APIServer}inapp/INAPP_ID`,

  // RULES
  RULES_FETCH: `${APIServer}rules/admin/list`,
  RULES_JOURNEYS: `${APIServer}rules/admin/journey_list/ID`,
  RULES_JOURNEYS_UPDATE: `${APIServer}rules/admin/multiple_journeys/update/ID`,
  RULES_CREATE: `${APIServer}rules/admin/create`,
  RULES_UPDATE: `${APIServer}rules/admin/update/ID`,
  RULES_BY_ID: `${APIServer}rules/admin/ID`,
  RULES_REMOVE_JOURNEY: `${APIServer}rules/admin/journey/remove/ID`,
  RULE_REMOVE: `${APIServer}rules/admin/remove/ID`,
  RULES_JOURNEY_CHECK: `${APIServer}rules/admin/journey/ID`,

  // PX DASHBOARD
  PX_HUBSPOT_ACT: `${APIServer}px_dashboard/admin/px/dealership_insights/hubspot_activity/ID`,
  PX_INSIGHTS: `${APIServer}px_dashboard/admin/px/dealership_insights/ID`,
  PX_EMAIL: `${APIServer}px_dashboard/admin/usage_report/email`,
  PX_REPORT_EMAIL: `${APIServer}px_dashboard/admin/px_report/email`,
  PX_EMP_DISABLE: `${APIServer}employees/admin/HASH/status`,
  PX_FILTERS: `${APIServer}px_dashboard/admin/filters`,
  PX_REPORT: `${APIServer}px_dashboard/admin/report`,
  PX_TAB_COUNT: `${APIServer}px_dashboard/admin/report_tab_count`,
  PX_OWNERS: `${APIServer}px_dashboard/admin/px_owners`,
  PX_EMPLOYESS: `${APIServer}px_dashboard/admin/dealership/employs/ID`,
  PX_MANAGERS: `${APIServer}px_dashboard/admin/dealership/managers/ID`,
  PX_ASSIGNED_JOURNEYS: `${APIServer}px_dashboard/admin/dealership/tom/journeys/ID`,
  PX_DEALER_ASSIGNED_JOURNEY: `${APIServer}v3/dashboard/admin/journey/dealerAssignedJourneys `,
  PX_LEARNING_HISTORY: `${APIServer}dashboard/admin/learning_history`,
  PX_USER_STATS: `${APIServer}v3/dashboard/admin/journey_stats/dealerAssignedJourneys/summary/ID`,

  REPORT_DEALER_HIERARCHY: `${APIServer}dealerships/hierarchy`,
  REPORT_REPORTS: `${APIServer}report`,
  REPORT_CHECKIN_REPORT: `${APIServer}checkin/admin/report/summary`,
  REPORT_CHECKIN_REPORT_OVERALL: `${APIServer}checkin/admin/report/overall`,
  REPORT_ER_HIERARCHY: `${APIServer}v2/enterprise_reporting/admin/hierarchy`,
  REPORT_ER: `${APIServer}v2/enterprise_reporting/admin`,
  REPORT_EXAMS_LIST: `${APIServer}exam/list/all`,
  REPORT_EXAMS: `${APIServer}report/exam_analysis_report/email`,

  // ROCKED CURRICULUM
  RC_YOE: `${APIServer}rocked_curriculum/years_of_experience/ID?curriculumType=collection`,
  RC_DEP_ROLES: `${APIServer}department_roles`,
  RC_SELECTED_COLLECTONS: `${APIServer}rocked_curriculum/collections_in_curriculum/ID`,
  RC_COLLECTIONS_LIST: `${APIServer}rocked_curriculum/collections/list/ID`,
  RC_COLLECTIONS: `${APIServer}rocked_curriculum/addUpdate/collections/ID`,

  // FUELS
  FUEL_TEMPLATE_BY_ID: `${APIServer}rocked_fuel/admin/fuel_templates/update/ID`,
  FUEL_TEMPLATE_CREATE: `${APIServer}rocked_fuel/admin/fuel_templates/create`,
  FUEL_ACTIVITY_UPDATE: `${APIServer}rocked_fuel/admin/fuel_templates/activities/update/ID`,
  FUEL_DEPARTMENTS: `${APIServer}rocked_fuel/admin/departments`,
  FUEL_BY_ID: `${APIServer}rocked_fuel/admin/ID`,
  FUEL_FETCH: `${APIServer}rocked_fuel/admin/list/ID`,
  FUEL_CREATE: `${APIServer}rocked_fuel/admin/create`,
  FUEL_UPDATE: `${APIServer}rocked_fuel/admin/update/ID`,
  FUEL_FETCH_TEMP_INFO: `${APIServer}rocked_fuel/admin/fuel_templates/ID`,
  FUEL_TEMPLATE_DEL: `${APIServer}rocked_fuel/admin/fuel_template/ID`,
  FUEL_REORDER_TEMPS: `${APIServer}rocked_fuel/admin/re_order_templates/ID`,
  FUEL_FETCH_INTERACTION: `${APIServer}rocked_fuel/admin/interaction_activity_types`,
  FUEL_CATEGORIES: `${APIServer}rocked_fuel/admin/categories`,

  // TOPIC
  TOPIC_DELETE: `${APIServer}topic_of_the_month/admin/topic/delete/ID`,
  TOPIC_CHECKIN: `${APIServer}checkin/admin/ID`,
  TOPIC_BY_ID: `${APIServer}topic_of_the_month/admin/topic/ID`,
  TOPIC_CREATE: `${APIServer}topic_of_the_month/admin/topic/create`,
  TOPIC_UPDATE: `${APIServer}topic_of_the_month/admin/topic/update/ID`,
  TOPIC_CHECKIN_CREATE: `${APIServer}checkin/admin/topic/create`,
  TOPIC_CHECKIN_UPDATE: `${APIServer}checkin/admin/topic`,
  TOPIC_ADD_JOURNEY: `${APIServer}topic_of_the_month/admin/topic/add_journeys/ID`,

  // TOM
  TOM_TOPICS: `${APIServer}topic_of_the_month/admin/topic/list`,
  TOM_TOPIC_DEALERS: `${APIServer}topic_of_the_month/admin/topics_dealerships/ID`,
  TOM_ASSIGN: `${APIServer}topic_of_the_month/admin/assign`,
  TOM_DATES: `${APIServer}topic_of_the_month/admin/dates`,
  TOM_TOPICS_BY_DATES: `${APIServer}topic_of_the_month/admin/topics`,
  TOM_TABLE: `${APIServer}topic_of_the_month/admin/topics/completion_table`,
  TOM_END_ASSIGNMENT: `${APIServer}topic_of_the_month/admin/end`,
  TOM_EDIT_ASSIGNMENT: `${APIServer}topic_of_the_month/admin/edit`,

  // Certification
  CERT_ALL_CERTS: `${APIServer}rockedAdmin/v1/certification/list`,
  CERT_CERT_INFO: `${APIServer}rockedAdmin/v1/certification/overview/ID`,
  CERT_CERT_INFO_EDIT: `${APIServer}rockedAdmin/v1/certification/detail/ID`,
  CERT_CERT_INFO_STATS: `${APIServer}certification/admin/details/ID/stats`,
  CERT_CREATE: `${APIServer}rockedAdmin/v1/certification/create`,
  CERT_UPDATE: `${APIServer}rockedAdmin/v1/certification/update/ID`,
  CERT_DELETE: `${APIServer}rockedAdmin/v1/certification/ID`,
  CERT_ALL_ISSUER: `${APIServer}rockedAdmin/v1/issuer/list`,
  CERT_CREATE_ISSUER: `${APIServer}rockedAdmin/v1/issuer/create`,
  CERT_ISSUER_INFO: `${APIServer}rockedAdmin/v1/issuer/detail/ID`,
  CERT_ISSUER_UPDATE: `${APIServer}rockedAdmin/v1/issuer/update/ID`,
  CERT_ISSUER_DELETE: `${APIServer}rockedAdmin/v1/issuer/ID`,
  CERT_JOURNEYS: `${APIServer}rockedAdmin/v1/certification/journeys`,
  CERT_JOURNEYS_UPDATE: `${APIServer}rockedAdmin/v1/certification/updateJourneys/ID`,
  CERT_EXAM_JOURNEYS: `${APIServer}rockedAdmin/v1/certification/exam/journeyGuides/ID `,
  CERT_EXAM_QUE_CAT: `${APIServer}rockedAdmin/v1/certification/exam/questionCategories`,
  CERT_EXAM_CREATE: `${APIServer}rockedAdmin/v1/certification/exam/create`,
  CERT_EXAM_DETAIL: `${APIServer}rockedAdmin/v1/certification/exam/detail/ID`,
  CERT_EXAM_UPDATE: `${APIServer}rockedAdmin/v1/certification/exam/update`,
  CERT_ASSIGN_DEALER_LIST: `${APIServer}rockedAdmin/v1/certification/assign/dealership/list`,
  CERT_ASSIGN: `${APIServer}rockedAdmin/v1/certification/assign`,
  CERT_SKILLS: `${APIServer}skills/admin`,
  CERT_RNP_LIST: `${APIServer}rockedAdmin/v1/rockedNetworkPartners/list`,

  // Dealership List (DevPanel)
  DEALERSHIP_DETAIL_LIST: `${APIServer}rockedAdmin/v1/dealership/detail/list`,
  DEALERSHIP_META: `${APIServer}rockedAdmin/v1/dealership/meta`,
  UPDATE_DEALERSHIP: `${APIServer}rockedAdmin/v1/dealership/update`,
  CREATE_DEALERSHIP_META: `${APIServer}rockedAdmin/v1/dealership/meta/create`,
  UPDATE_DEALERSHIP_META: `${APIServer}rockedAdmin/v1/dealership/meta/update`,
  DELETE_DEALERSHIP_META: `${APIServer}rockedAdmin/v1/dealership/meta/delete`,

  // AI Roleplay
  AI_EXERCISE_CATEGORIES: `${APIServer}aiRolePlay/admin/topic`,
  AI_EXERCISE: `${APIServer}aiRolePlay/admin/exerciseByTopics/ID`,
  AI_CREATE_CATEGORY: `${APIServer}aiRolePlay/admin/topic`,
  AI_TOPIC_INFO: `${APIServer}aiRolePlay/admin/topic/ID`,
  AI_DELETE_TOPIC: `${APIServer}aiRolePlay/admin/topic/ID`,
  AI_EXERCISE_TYPES: `${APIServer}aiRolePlay/admin/exerciseTypes`,
  AI_CHARACTERS: `${APIServer}aiRolePlay/admin/aiCharacters`,
  AI_CREATE_EXERCISE: `${APIServer}aiRolePlay/admin/exercise`,
  AI_DELETE_EXERCISE: `${APIServer}aiRolePlay/admin/exercise/ID`,
  AI_FILTERED_JOURNEY: `${APIServer}journeys/admin/filter_journey`,
  AI_GET_EXERCISE_INFO: `${APIServer}aiRolePlay/admin/exercise/ID`,
  AI_GET_EXERCISE_DEPARTMENTS: `${APIServer}aiRolePlay/exercise/departments`,
  AI_GET_ROCKED_NETWORK_PARTNERS: `${APIServer}rockedAdmin/v1/rockedNetworkPartners/`,

  // VIMEO
  VIMEO_SEARCH: `${APIServer}rockedAdmin/v1/vimeo/searchVideos`,
};
